import React from 'react'
import { StandardOpenModalButton } from 'src/components/ModalForms/ModalButtons'
import {
  useHideModal,
  useIsShowModal,
  useSetActiveModal,
} from 'src/Modal/ModalStateContext'
import { ModalForm, ModalFormId } from '../../..'
import { Spinner } from '../../../../../Throbber'
import { useFrameworkWizard } from '../../../../../context/FormContext'
import { SelectPoliciesModal } from './SelectPoliciesModal'

export const ReusablePoliciesModal = (): JSX.Element => {
  const {
    frameworkState: { framework },
    policiesState: { policiesInAccount },
    loadingState: { loading },
  } = useFrameworkWizard()

  const hide = useHideModal({ modalId: ModalFormId.REUSABLE_POLICIES })
  const show = useIsShowModal(ModalFormId.REUSABLE_POLICIES)
  const back = useSetActiveModal(ModalFormId.SELECT_CONTROLS)
  return (
    <div>
      <SelectPoliciesModal />
      <ModalForm
        show={show}
        hide={hide}
        formId={ModalFormId.REUSABLE_POLICIES}
        size="xl"
        title={`Linking Existing Policies to ${framework?.getName()}`}
        onBack={back}
        customSubmitButton={
          <StandardOpenModalButton modalId={ModalFormId.SELECT_POLICIES} />
        }
      >
        {loading ? (
          <Spinner color={'primary'} size={'m'} />
        ) : (
          <form id={ModalFormId.REUSABLE_POLICIES}>
            <p>{`Good news! ${
              policiesInAccount.length
            } of your policies can be used for ${framework?.getName()}`}</p>
            <ul style={{ marginTop: '1em' }}>
              {policiesInAccount.map((item, idx) => (
                <li key={`${item.getId() + idx}`}>{item.getName()}</li>
              ))}
            </ul>
          </form>
        )}
      </ModalForm>
    </div>
  )
}
